/**
 * Created by desheng.zhao on 2019/2/21.
 */

// 按页面划分
export default {
  // 公共页面
  common: {
    fill: "Required",
    fillError: "Invalid",
    fillHasError: "The field is empty or invalid",
    ajaxError: "Something went wrong",
    networkError: "Network unavailable",
    tokenExpire: "You haven\'t logged in, or your previous session has expired",
  },
  //邮箱登录
  emailLogin: {
    title: 'Login',
    subTitle: "Login with Email",
    emailAccount: "Email",
    password: "Password",
    emailEmpty: "Please enter your email",
    emailError: "Invalid email",
    checkEmail: "Invalid email",
  },
  // 登录
  login: {
    title: "Login",
    subTitle: "Login with Mobile",
    phoneNo: "Phone number",
    password: "Password",
    msgCode: "SMS verification code",
    getMsgCode: "Get Code",
    getMsgInterval: "s later to resend",
    loginBtn: "Login",
    registerBtn: "Register",
    resetBtn: "Forgot Password",
    phoneEmpty: "Please enter your phone number",
    phoneError: "Invalid phone number",
    checkPhone: "Invalid phone number",
    fillMsgCode: "Please enter the SMS verification code",
    fillPassword: "Please enter the password",
    fill: "Required",
    fillError: "Invalid",
    hasError: "The field is empty or invalid",
    loginSuccess: "Login successful",
    needMsgCheck: "A verification code is required to log in",

  },
  // 注册
  register: {
    title: "Register",
    subTitle: "Register via Mobile",
    phoneNo: "Phone number",
    password: "Password must be 6-20 characters long",
    repeatPwd: "Confirm password",
    msgCode: "SMS verification code",
    getMsgCode: "Get Code",
    getMsgInterval: "s later to resend",
    picCode: "Image verification code",
    getPicCode: "Get Code",
    registerBtn: "Register",
    auth: {
      tip: "By registering you have read and agreed to the",
      agreeMent: "User Agreement",
      and: "and",
      policy: "Privacy Policy"
    },
    footer: "For any questions, please contact us on WeChat",

    phoneEmpty: "Please enter your phone number",
    phoneError: "Invalid phone number",
    fillPassword: "Please enter your password",//"Password must be 6-20 characters long",
    pwdInvalidLetter: "Password contains invalid characters",
    pwdLenLow: "Password must be greater than 6 characters long",
    pwdNeedLetter: "Password must contain letters or special characters",
    pwdNeedNum: "Password must contain digits",
    pwdLenUp: "Password must be less than 20 characters long",
    fillRepeatPwd: "Please re-enter the password",
    RepeatPwdError: "Passwords do not match",
    fillMsgCode: "Please enter the SMS verification code",
    fillPicCode: "Please enter the image verification code",
    getPicCodeFirst: "Please obtain the image verification code first",
    registSuccess: "Registration successful",

  },
  // 找回密码
  reset: { // 找回密码很多字段和注册一样，就直接调用注册的
    title: "Reset Password",
    subTitle: "Reset Password",
    resetBtn: "Confirm & Login",

  },
  // 登录成功
  loginSuccess: {
    title: "Login successful",
    logAccount: "You are logged in",
    toBindBtn: "Link device",
    toShareBtn: "Share data",
    logOutBtn: "Log out",
    footer: "If you have no device, please contact us on WeChat",

    isLogout: "Are you sure you want to log out?",
    confirmText: "Confirm",
    cancelText: "Cancel",
    logOutSuccess: "You have logged out successfully",
  },
  // 绑定设备
  binding: {
    title: "Link device",
    imei: "Device IMEI",
    fillImei: "Please enter the device IMEI",
    password: "Device password",
    fillPwd: "Please enter the device password",
    bindBtn: "Link Now",
    needImei: "Please enter the device IMEI",
    needPwd: "Please enter the device password",
  },
  // 绑定设备成功
  binded: {
    title: "Linked successfully",
    bindedMachine: "Device is linked successfully",
    toShare: "Share SIM data",
    unbind: "Unlink",
    unbindSuccess: "Unlink successfully",
    isUnbind: "Do you want to unlink the device？",
    confirmText: "Confirm",
    cancelText: "Cancel",
  },
  // 卡分享详情
  shareDetail: {
    title: "Data sharing details",
    imei: "Device IMEI",
    online: "Online",
    offline: "Offline",
    tip: "Tips",
    footer: "For any questions, please contact us on WeChat",
    submitSuccessTip: "Submission successful. The order is being processed. Please confirm and share after approval.",
    alertButtonText: "OK",
    offlineOperateTip: "Unable to operate when device is offline",
    offlineTip: "The device is offline and please check the device status . For any questions, please join our QQ group for assistance，",
    unbindedTip: "This device has been unlinked and please link again",
    cancelSuccess: "Successfully cancelled",

    simShareInfo: { // sim-share-info
      simShareInfo: "Data sharing details",
      phone: "Phone number",
      flow: "Share data",
      price: "Price",
      shareEndTime: "Valid until",
      cancelShareBtn: "Don't share",
      confirmShareBtn: "Confirm & Share",
    },

    simShareSuccess: {
      shareSuccess: "Successfully shared",
      tip: "To ensure the data sharing, please keep your device stay online",
      alertBtnText: "OK"
    },

    submitSimInfo: {
      title: "Enter the SIM information",
      phone: "Phone number",
      phonePh: "Phone number", // ph  placeholder
      flow: "Share data",
      flowPh: "{flow}GB below",
      shareEndTime: "Valid until",
      shareEndTimePh: "Expire on",

      operator: "Carrier",
      operatorPh: "Select carrier",
      pickerConfirmText: "Confirm",
      pickerCancelText: "Cancel",

      cancelBtn: "Cancel",
      submitBtn: "Submit",

      needPhone: "Please enter your phone number",
      phoneError: "Invalid phone number",
      needFlow: "Please enter the sharing data limit",
      flowTip: "The data limit must be an integer less than {flow}",
      flowCannot0: "The data limit cannot be 0",
      flowCannotMinus: "The data limit cannot be minus",
      fillShareEndTime: "Please enter the expiration date",
      selectOperator: "Please select a carrier",
    },

    oneSim: {
      dataError: "Error. ",
      tryAgain: "Refresh",
      loading: "Loading……",
      detectedSim: "SIM detected",
      toShare: "Share",
      detectedNoSim: "No SIM",
      enterSim: "Please install the SIM card",
      status00: "Waiting sharing",
      status01: "Pending",
      status02: "Approved. Please confirm",
      status03: "Rejected",
      status04: "Sharing",
      status05: "Interrupted",
      status06: "Re-share",
      status07: "Cancel",
      status08: "SIM abnormal",
    }
  },
  // 提现记录
  withdrawRecord: {
    title: "Withdrawal History ",
    totalProfit: "Total bonuses",
    canWithdrawAmount: " Available balance (CNY)",
    withdraw: "Withdraw",
    withdrawRecord: "Withdrawal history",
    withdrawAmount: "Amount withdrawn",
    moreRecord: "View more",
    noMoreData: "sorry, no more data to display",
    footer: "For any questions, please contact us on WeChat",
    cannotWithdraw: "You haven’t shared any data yet. Try to share it",
    noRecord: "No records",
    contactMe: "Please follow 插卡宝 on WeChat or add QQ ID 738605106 for customer service"
  },
  // 提现
  withdraw: {
    title: "Withdrawal",
    canWithdrawAmountTip: "Amount to withdraw (CNY)",
    withdrawPre: "￥",
    // amountPh: "Please enter the withdrawal amount",
    amountPh: "Enter the withdrawal amount",
    canWithdrawAmount: "Available balance {amount}",
    withdrawAll: "Withdraw all",
    withdrawTo: "Withdraw to",
    wechatWallet: "WeChat Wallet",
    sendMethod: "By Red Packet",// "Red packet sent",
    nameConfirm: "Verify identity",
    namePh: "Please enter your real name",
    withdrawBtn: "Withdraw",
    tip: "The remittance is available from 11:00 to 18:00 on Friday (excluding public holidays)",
    footer: "For any questions, please contact us on WeChat",

    needName: "Please enter your real name",
    withdrawTip: "Request received. The amount will be transferred to you on Friday. For any questions, please join our QQ group for assistance. {QQ}",
    alertButtonText: "OK",
    needAmount: "Please enter the withdrawal amount ",
    amountIsNaN: " The withdrawal amount must be digits ",
    amountLg: " Withdrawal beyond available amount",
    twoDecimalPlaces: "It only supports 2 decimal places ",
    amountNegative: "The withdrawal amount cannot be negative",
    amountIs0: "The withdrawal amount cannot be 0",
    usernameError: "Invalid username"
  },
  // 历史订单
  historyOrders: {
    title: " Order History",
    createOrderTime: "Order Date",
    sharedFlow: "Data Shared",
    moreOrder: "View more",
    noMoreData: " sorry, no more data to display ",
    footer: " For any questions, please contact us on WeChat",
    noOrder: "You haven't placed any orders yet",
  },
  // 订单详情
  orderDetail: {
    title: "Order Details ",
    phone: "Phone No. ",
    flow: "Data Shared",
    createOrderTime: "Order Date",
    price: "Data Rate",
    orderId: "Order ID ",
    footer: "For any questions, please contact us on WeChat",
  },
  // 无设备
  noSim: {
    title: "Data sharing details",
    noCard: "No SIM available",
    toBind: "Already have a device. Link now",
    footer: "If you have no device, please contact us on WeChat",
  },
  // 设置
  setting: {
    title: "Settings",
    device: "My device",
    language: "Language",
    logOut: "Logout"
  },
  // 切换语言
  changeLanguage: {
    title: "Language"
  },
  // 隐私政策
  policy: {
    title: "Privacy Policy"
  },
  // 切换语言
  agreement: {
    title: "User Agreement"
  },
  // 首页
  home: {
    title: "Data Share",
    totalFit: "Total bonuses",
    withdraw: "Withdraw",
    withdrawHistory: "Withdrawal history",
    historyOrder: "Order history",
    instruction: "Guidelines",
    myDevices: "My devices",
    boxName: "SIMBOX",
    online: "Online",
    offline: "Offline",
    imeiNum: "IMEI No.",
    addDevice: "Scan QR code to add device",
    noDevice: "There are currently no linked devices",
    noFit: "No bonuses",
    noSignal: "No signal",
    profitUnit: "CNY",
    unknownPhone: "Unknown device",
    openInApp: "This function is only available on SIMBOX App"
  },
  // 预约码
  reservationCode: {
    title: "Data share",
    inputCodeTip: "Enter your reservation code",
    noCode: "If you don't have the reservation code, contact customer service.",
    codePlaceholder: "Enter your reservation code",
    btnText: "Confirm",
    auth: {
      tip: "By clicking Confirm, you have read and agree to the ",
      agreeMent: "User Agreement",
      and: "and",
      policy: "Privacy Policy"
    },
    validateSuccess: "Verification successful",
  },
  // 使用说明
  instruction: {
    title: "Guidelines",
    step1: "1. Open your GlocalMe Call app, go to Me > SIM  Manager > Share SIM card, and then tap \"Share data\"",
    step1Remark: "(Note: Once enabled, it will affect your ability to access calls or messages temporarily, and you can cancel it at any time before you submit the request)",
    step2: "2. Tap \"Confirm\" or tap \"Share data\" on the \"Me\" page to submit your request;",
    step3: "3. On the \"Share data\" page, you can proceed to share data. Once the request is approved, you will be able to view the sharing status and amount.",
    readBtn: "OK，got it",
  },
  // 所有的过渡页面
  pages: {
    userCenter: "Me",
    myMachine: "My device"
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js